import { css } from 'lit';

export const styles = css`
  /* Dialog sizing */
  .work-order-dialog-large {
    --width: 90vw;
    --height: 85vh;
    max-width: 1200px;
    max-height: 800px;
  }

  .work-order-header {
    margin-bottom: 1.5rem;
    text-align: center;
  }

  .work-order-header h3 {
    margin: 0 0 1rem 0;
    color: var(--sl-color-neutral-900);
    font-size: 1.5rem;
    font-weight: 600;
  }

  .badges {
    display: flex;
    gap: 0.5rem;
    justify-content: center;
  }

  /* Tab content styling */
  sl-tab-panel {
    padding-top: 1rem;
  }

  /* Details tab styling */
  .details-grid {
    display: grid;
    gap: 1.5rem;
  }

  .field-row {
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
  }

  .field-row label {
    font-weight: 600;
    color: var(--sl-color-neutral-700);
    font-size: 0.875rem;
  }

  .field-row sl-input,
  .field-row sl-textarea,
  .field-row sl-select {
    width: 100%;
  }

  /* Parts tab styling */
  .parts-usage-container {
    display: grid;
    grid-template-rows: auto auto 1fr;
    gap: 1.5rem;
    height: 60vh;
    min-height: 500px;
  }

  .add-part-section {
    background: var(--sl-color-neutral-50);
    border-radius: 8px;
    padding: 1.5rem;
    border: 1px solid var(--sl-color-neutral-200);
  }

  .add-part-section h4 {
    margin: 0 0 1rem 0;
    color: var(--sl-color-neutral-900);
    font-size: 1.1rem;
    font-weight: 600;
  }

  .add-part-form {
    display: grid;
    grid-template-columns: 2fr 1fr auto;
    gap: 1rem;
    align-items: end;
  }

  .cost-preview {
    grid-column: 1 / -1;
    background: var(--sl-color-neutral-0);
    border-radius: 6px;
    padding: 1rem;
    border: 1px solid var(--sl-color-neutral-200);
    margin-top: 1rem;
  }

  .cost-preview p {
    margin: 0.25rem 0;
    font-size: 0.875rem;
  }

  .available-parts-section,
  .parts-usage-section {
    background: var(--sl-color-neutral-0);
    border-radius: 8px;
    border: 1px solid var(--sl-color-neutral-200);
    overflow: hidden;
  }

  .available-parts-section {
    min-height: 200px;
  }

  .parts-usage-section {
    min-height: 250px;
  }

  /* Mobile responsive */
  @media (max-width: 768px) {
    .work-order-dialog-large {
      --width: 95vw;
      --height: 90vh;
    }

    .add-part-form {
      grid-template-columns: 1fr;
      gap: 1rem;
    }

    .parts-usage-container {
      height: 50vh;
      min-height: 400px;
    }
  }

  /* Ensure tables fit properly */
  data-table {
    height: 100%;
    width: 100%;
  }
`;
